import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import {
  BackResponse,
  BackResponseFailure,
  InternalService,
} from '@savgroup-front-common/types';

import { buildUrl, prepareResponseFailure } from '../../helpers';
import { apiCall } from '../../services';

const ENDPOINT = `${APIConfiguration.repairer}files/${COMMON_QUERY_PARAMS.FILE_ID}/services`;

export interface GetAvailableServicesForInterventionReportByFileIdArgs {
  fileId: string;
  directPaymentOnly?: boolean;
}

export const getAvailableServicesForInterventionReportByFileId = async (
  payload: GetAvailableServicesForInterventionReportByFileIdArgs,
): Promise<BackResponse<InternalService[]> | BackResponseFailure> => {
  const url = buildUrl(
    ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, payload.fileId),
    {
      directPaymentOnly: payload.directPaymentOnly ?? false,
    },
  );

  try {
    return await apiCall<BackResponse<InternalService[]>>(url, {
      method: SUPPORTED_METHODS.GET,
    });
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
